import styled from 'styled-components';
import { scrollBarStylesGeneral } from '@doltech/utils/lib/css-style';

interface Props {
  maxHeight?: number;
}
export const ScrollableOptionListLayout = styled.div<Props>`
  max-height: ${props => props.maxHeight || 300}px;
  padding: 0 14px;
  overflow-y: auto;
  ${scrollBarStylesGeneral()}
`;
